import React from 'react'
import {Col, Row, Panel, FormGroup, FormControl, Button} from 'react-bootstrap'
import DateTime from 'react-datetime'
import MultiSelect from '../../../common/form/multi-select'

const PointsTransactionsSearch = (props) => {

  return (
    <Panel className="order-filter">
      <Row>
        <Col md={4}>
          <FormGroup>
            <FormControl onChange={props.onInputChange}
                         placeholder="Enter customer number"
                         value={props.searchValue}/>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime timeFormat={false}
                      dateFormat="DD/MM/YYYY"
                      value={props.dateFromValue}
                      onChange={props.onDateFromChange}
                      closeOnSelect
                      inputProps={{
                        placeholder: 'Date from'
                      }}/>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <DateTime timeFormat={false}
                      dateFormat="DD/MM/YYYY"
                      value={props.dateToValue}
                      onChange={props.onDateToChange}
                      closeOnSelect
                      inputProps={{
                        placeholder: 'Date to'
                      }}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <MultiSelect data={props.pointsPotList}
                         value={props.pointsPotValue}
                         onChange={props.onPointsPotChange}
                         controlId="pointsPot"/>
          </FormGroup>
        </Col>
        <Col md={6} className="actions">
          <Button className="red-ghost-btn"
                  onClick={props.onSearch}>Search</Button>

          <Button className="red-ghost-btn"
                  onClick={props.onClear}>Clear search/filters</Button>
        </Col>
      </Row>
    </Panel>
  );
};

export default PointsTransactionsSearch;


// WEBPACK FOOTER //
// ./src/components/admin/points/points-transactions/points-transactions-search.jsx